var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoGreyIcon = function SvgInfoGreyIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#888B94",
    fillRule: "evenodd",
    d: "M8 13.94A5.44 5.44 0 1 0 8 3.06a5.44 5.44 0 0 0 0 10.88m0 .96A6.4 6.4 0 1 0 8 2.1a6.4 6.4 0 0 0 0 12.8",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#888B94",
    d: "M9.029 11.244a.457.457 0 0 1-.457.457.914.914 0 0 1-.915-.915V8.502a.457.457 0 1 1 0-.914.914.914 0 0 1 .915.914v2.286a.457.457 0 0 1 .457.457M7.2 5.987a.686.686 0 1 1 1.372 0 .686.686 0 0 1-1.372 0"
  })));
};
export default SvgInfoGreyIcon;